import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export default function MobileLogin() {
  const [searchParams] = useSearchParams();
  const isApp = searchParams.get('app') === 'true';
  const { login, user, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    // FCM token save - runs on login page load
    window.saveFCMToken = async (token) => {
      try {
        const res = await fetch('https://vbot.co.in/api/notifications/save-device-token', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ user_id: 1, business_id: 13, token: token })
        });
        console.log('FCM token saved from login:', token);
      } catch (error) {
        console.log('Error saving token:', error);
      }
    };
  }, []);

  useEffect(() => {
    if (!loading && user && isApp) {
      navigate('/mobile-inbox?app=true');
    }
  }, [user, loading]);

  if (!isApp) {
    return (
      <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'#f3f4f6' }}>
        <div style={{ textAlign:'center', padding:40 }}>
          <div style={{ fontSize:48, marginBottom:16 }}>🔒</div>
          <h2 style={{ color:'#111', fontFamily:'DM Sans,sans-serif' }}>Access Denied</h2>
          <p style={{ color:'#6b7280', fontFamily:'DM Sans,sans-serif' }}>This page is only accessible from the mobile app.</p>
        </div>
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError('');
    try {
      await login(email, password);
      navigate('/mobile-inbox?app=true');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={{
      minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center',
      background:'linear-gradient(135deg, #0f8f5f, #0c7a50)', fontFamily:'DM Sans, sans-serif'
    }}>
      <div style={{ background:'#fff', padding:40, borderRadius:18, width:340, boxShadow:'0 20px 50px rgba(0,0,0,.15)', textAlign:'center' }}>
        <div style={{ fontSize:36, marginBottom:8 }}>💬</div>
        <h2 style={{ marginBottom:4, color:'#111' }}>VFlow</h2>
        <p style={{ color:'#6b7280', fontSize:13, marginBottom:24 }}>WhatsApp Business</p>
        {error && (
          <div style={{ background:'#fee2e2', color:'#991b1b', padding:'10px 14px', borderRadius:8, marginBottom:16, fontSize:13 }}>
            {error}
          </div>
        )}
        <form onSubmit={handleSubmit}>
          <input
            type="email" placeholder="Email" value={email}
            onChange={e => setEmail(e.target.value)} required
            style={{ width:'100%', padding:'12px 14px', border:'1px solid #e5e7eb', borderRadius:10, fontSize:14, marginBottom:12, boxSizing:'border-box' }}
          />
          <input
            type="password" placeholder="Password" value={password}
            onChange={e => setPassword(e.target.value)} required
            style={{ width:'100%', padding:'12px 14px', border:'1px solid #e5e7eb', borderRadius:10, fontSize:14, marginBottom:16, boxSizing:'border-box' }}
          />
          <button type="submit" disabled={submitting}
            style={{ width:'100%', padding:12, background:'#25D366', color:'#fff', border:'none', borderRadius:10, fontSize:15, fontWeight:600, cursor:'pointer' }}>
            {submitting ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
}
